import { Progress } from "antd";
import _ from "lodash";
import styles from "./DashboardTableShare.module.scss";

function DashboardTableShare({ total, value }: { total: number; value?: number }) {
  const percentage = _.round((total / (value || 1)) * 100, 2).toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return (
    <div className={styles.container}>
      <div className={styles.percentageBarContainer}>
        <Progress
          percentPosition={{
            align: undefined,
          }}
          strokeColor={"#8C8C8C"}
          percent={Number(percentage)}
          showInfo={false}
          size="small"
        />
      </div>
      <div className={styles.percentageContainer}>
        <span className={styles.percentage}>{percentage + "%"}</span>
      </div>
    </div>
  );
}

export default DashboardTableShare;
